import { BaseViewStore } from 'core/stores';
import { ChannelStore } from 'modules/channel/stores';
import { ApplicationStore } from 'platform/application/stores';
import { AmazonTemplatesForm } from 'modules/order/forms';
import { action, makeObservable } from 'mobx';
import { sourceOfChange, viewStoreName } from 'common/constants';
import _ from 'lodash';

class AmazonTemplatesViewStore extends BaseViewStore {
	channel;
	amazonTemplates = [];
	form = new AmazonTemplatesForm({
		onSuccess: async () => {
			await this.updateChannelAmazonTemplates();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.channelStore = new ChannelStore(rootStore);
		this.applicationStore = new ApplicationStore(rootStore);
		this.isListOrEditStore =
			modalParams.data.store_path === viewStoreName.channelListViewStore || modalParams.data.isEdit;
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		if (this.isListOrEditStore) {
			this.channel = await this.channelStore.getChannel(this.modalParams.data.selectedItem.id, {
				embed: ['seller', 'amazonTemplates', 'channelType'],
			});
			this.amazonTemplatesModel = {
				amazonTemplates: this.channel.amazonTemplates,
				defaultPrimeTemplate: this.channel.defaultPrimeTemplate,
			};
		} else {
			this.amazonTemplatesModel = this.modalParams.data.amazonTemplatesModel;
		}
		await this.prepareData();
		this.resume();
	};

	@action.bound
	addAmazonTemplate = async () => {
		this.form.$('amazonTemplates').add([
			{
				systemCode: '',
				amazonCode: '',
			},
		]);
	};

	@action.bound
	prepareData = async () => {
		_.each(this.amazonTemplatesModel.amazonTemplates, amazonTemplate => {
			this.form.$('amazonTemplates').add([
				{
					systemCode: amazonTemplate.systemCode,
					amazonCode: amazonTemplate.amazonCode,
				},
			]);
		});
		this.form.$('defaultPrimeTemplate').value = this.amazonTemplatesModel.defaultPrimeTemplate;
	};

	@action.bound
	updateChannelAmazonTemplates = async () => {
		this.suspend();
		try {
			if (this.isListOrEditStore) {
				await this.channelStore.updateChannelAmazonTemplates(
					{
						channelId: this.channel.id,
						...this.form.values(),
					},
					this.modalParams.data.store_path === 'channelListViewStore'
						? sourceOfChange.channelListUpdatelAmazonTemplates
						: sourceOfChange.channelEditUpdateAmazonTemplates
				);
				this.rootStore.notificationStore.success(['AMAZONTEMPLATES.SUCCESS', { channelName: this.channel.name }]);
			} else {
				this.modalParams.data.amazonTemplatesModel = this.form.values();
				this.rootStore.notificationStore.success(['AMAZONTEMPLATES.UPDATED']);
			}
			this.modalParams.success();
		} catch (err) {
			this.rootStore.notificationStore.error(['AMAZONTEMPLATES.ERROR', { channelName: this.channel.name }]);
		}
		this.resume();
	};
}

export default AmazonTemplatesViewStore;



// WEBPACK FOOTER //
// ./src/modules/channel/stores/AmazonTemplatesViewStore.js